import { Post } from "../lib/sanity/types";

const getImageUrl = (post: Post) => {
  if (post.mainImage?.asset?.url) {
    return post.mainImage.asset.url;
  }
  return "/images/home/blog-post.jpg";
};

export default getImageUrl;
